import React, { useState } from 'react';
import MDBox from 'components/MDBox';
import { makeStyles } from '@mui/styles';
import DataTable from 'examples/Tables/DataTable'
import { TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import MDTypography from 'components/MDTypography';

const EntitySelectDataTable = ({ rowData, selectedRows, setSelectedRows }) => {
    const useStyles = makeStyles({
        root: {
            '& .MuiDataGrid-row.Mui-selected': {
                backgroundColor: 'rgba(0, 0, 255, 0.3)', // Customize selected row background color
            },
            '& .MuiDataGrid-row.Mui-selected:hover': {
                backgroundColor: 'rgba(0, 0, 255, 0.3)', // Keep the same background color on hover
            },
            '& .MuiDataGrid-row:hover': {
                backgroundColor: 'rgba(0, 0, 255, 0.04)', // Customize background color on hover
            },
            '& .MuiDataGrid-cell:focus-within': {
                outline: 'none', // Remove outline on cell focus
            },
        },
    });
    const classes = useStyles();

    const [searchQuery, setSearchQuery] = useState('');

    // const filteredRows = rowData.filter((row) =>
    //   row.Entity?.name.toLowerCase().includes(searchQuery.toLowerCase())
    // );
    const filteredRows = rowData.filter((row) => {
        // Convert searchQuery to lowercase for case-insensitive comparison
        const searchLower = searchQuery.toLowerCase();

        // Check if any property value in any cell of the row matches the search query
        return Object.values(row).some((cellValue) => {
            // If cellValue is an object, extract its string representation for comparison
            if (typeof cellValue === 'object' && cellValue !== null) {
                cellValue = Object.values(cellValue).join(' ');
            }
            // Check if the cellValue exists, is a string, and includes the search query (case-insensitive)
            return cellValue && typeof cellValue === 'string' && cellValue.toLowerCase().includes(searchLower);
        });
    });
    const columns = [
        {
            field: "id",
            accessor: "id",
            headerName: "Entity ID",
            Header: "Entity ID",
            flex: 1,
        },
        // {
        //   field: "Icon.icon_name",
        //   accessor: "Icon.icon_name",
        //   headerName: "Icon",
        //   Header: "Icon",
        //   flex: 0.5,
        //   width: 50,
        //   renderCell: (info) => {
        //     return <i className={`${info.row.Icon?.class_name}`} style={{ fontSize: "24px" }}></i> 
        //   },
        // },
        {
            field: "name",
            accessor: "name",
            headerName: "Entity Name",
            Header: "Entity Name",
            flex: 1,
            valueGetter: (params) => params.row.name,
        },
        {
            field: "company",
            accessor: "company",
            headerName: "Company",
            Header: "Company",
            flex: 1,
            //   valueGetter: (params) => params.row.Item?.name,
        },
        {
            field: "type",
            accessor: "type",
            headerName: "Type",
            Header: "Type",
            flex: 1,
        },
        // {
        //     field: "status",
        //     accessor: "status",
        //     headerName: "Status",
        //     Header: "Status",
        //     flex: 1,
        //     renderCell: (info) => {
        //         return <i className={`${info.row.Icon?.class_name}`} style={{ fontSize: "24px" }}></i>
        //     },
        // },
        {
            field: "address",
            accessor: "address",
            headerName: "Address",
            Header: "Address",
            flex: 1.2,
        },
        {
            field: "city",
            accessor: "city",
            headerName: "City",
            Header: "City",
            flex: 1,
        },
        {
            field: "state",
            accessor: "state",
            headerName: "State",
            Header: "State",
            flex: 1,
        },
    ];

    return (
        <MDBox display="flex" flexDirection="column">
            <MDBox display="flex" mb={1} alignItems="center" justifyContent="space-between">
                <MDTypography>Select Entity Address Item</MDTypography>
                <MDBox display="flex" justifyContent="right" alignItems="right">
                    <TextField
                        label="Search"
                        variant="outlined"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </MDBox>
            </MDBox>
            <DataGrid
                className={classes.root}
                rows={filteredRows}
                columns={columns}
                disableColumnFilter
                onRowSelectionModelChange={(value) => setSelectedRows(value)}
                rowSelectionModel={selectedRows}
                getRowId={(row) => row.id}
                sx={{
                    maxHeight: '70vh', // Limit the modal height to 80% of viewport height
                    color: '#fff'
                }}
            />
            {/* <DataTable table={{columns, rows: filteredRows}} selectedRows={selectedRows} setSelectedRows={setSelectedRows} isSelection={true} isMultiSelect={false} canSearch={true}/> */}
        </MDBox>
    );
};

export default EntitySelectDataTable;
